/* eslint-disable */
import jwt from 'jsonwebtoken';
import swal from 'sweetalert2';
import queryString from 'querystring'
import { cloneDeep, findIndex } from 'lodash';
import * as Chart from 'chart.js';

import { FILTER_PERTANYAAN, FILTER_CONFIRM } from '../constants';

export const showSwalLoading = function (text = '') {
    swal({
        text,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
    });
    return swal.showLoading();
}

function showSwalSuccess(text) {
    return swal({
        text,
        type: 'success'
    });
}

function toTitleCase(str) {
    if (!str) return '';

    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

function randomNumber(min, max) {
    return min + Math.random() * (max - min);
}

export const romanize = function (num) {
    if (isNaN(num)) return NaN;
    var digits = String(+num).split(''),
        key = [
            '',
            'C',
            'CC',
            'CCC',
            'CD',
            'D',
            'DC',
            'DCC',
            'DCCC',
            'CM',
            '',
            'X',
            'XX',
            'XXX',
            'XL',
            'L',
            'LX',
            'LXX',
            'LXXX',
            'XC',
            '',
            'I',
            'II',
            'III',
            'IV',
            'V',
            'VI',
            'VII',
            'VIII',
            'IX'
        ],
        roman = '',
        i = 3;
    while (i--) roman = (key[+digits.pop() + i * 10] || '') + roman;
    return Array(+digits.join('') + 1).join('M') + roman;
}

function alphabetize(num){
    var s = '', t;
  
    while (num > 0) {
      t = (num - 1) % 26;
      s = String.fromCharCode(65 + t) + s;
      num = (num - t)/26 | 0;
    }
    return s || undefined;
}

function setFormatNumber(integerNumber) {
    return parseInt(integerNumber, 10)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function isNullOrEmpty(data, checkWhiteSpace = false) {
    return (
        (!data && data !== 0) ||
        data === '' ||
        data === 'undefined' ||
        data === undefined ||
        (checkWhiteSpace && isOnlyWhiteSpace(data))
    );
}

function isOnlyWhiteSpace(data) {
    return data.replace(/ /g, '') === '';
}

function getUser() {
    let user = null;
    let token = localStorage.getItem('token');
    if (token) {
        let userData = jwt.decode(token);
        user = userData.user;
    }
    return user;
}
function verifikasiToken() {
    let user = null;
    let token = localStorage.getItem('token');
    if (token) {
        user = jwt.decode(token);
        if (!user) {
            return wrongLogin();
        }
        user = user.user;
        if (!user.roleId) {
            return wrongLogin();
        }
    } else {
        return wrongLogin();
    }

    return user;
}

function wrongLogin() {
    localStorage.removeItem('token');
    return (window.location = '/#/login');
}

function verifikasiRole(ray) {
    let user = verifikasiToken();
    let { roleId } = user;
    if (ray.indexOf(roleId) == -1) {
        return (window.location = '/#/home');
    }
}

function verifikasiPimpinan(perusahaanId) {
    let user = verifikasiToken();
    let { masterPerusahaanId } = user;
    if (!masterPerusahaanId) {
        localStorage.removeItem('token');
        return (window.location = '/#/login');
    }

    if (perusahaanId) {
        if (perusahaanId != masterPerusahaanId) {
            localStorage.removeItem('token');
            return (window.location = '/#/login');
        }
    }
}

function getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL();
    return dataURL;
}

function newImage(src, callback) {
    let img = new Image();
    img.src = src;
    img.onload = () => {
        callback(img);
    };
}

export const showError = async function (err) {
    if (err.response) {
        if (err.response.status === 401) {
            await swal('Oops...', err.response.data.message, 'error');
            return wrongLogin()
        }
        return swal('Oops...', err.response.data.message, 'error');
    } else if (err.message) {
        return swal(...[
            'Oops...',
            err.message,
            'error'
        ])
    }
    
    return swal(
        'Oops...',
        'No Internet Connection, please try again later',
        'error'
    );
}
function convertNaNToZero(val) {
    if (!val || isNaN(val)) return 0;
    return val;
}

function getWarna(angka) {
    let nilaiAkhir;
    let persentaseAkhir = parseFloat(angka);

    if (persentaseAkhir >= 90) nilaiAkhir = 'EMAS';
    else if (persentaseAkhir >= 76) nilaiAkhir = 'HIJAU';
    else if (persentaseAkhir >= 51) nilaiAkhir = 'BIRU';
    else if (persentaseAkhir >= 21) nilaiAkhir = 'MERAH';
    else nilaiAkhir = 'HITAM';

    return nilaiAkhir;
}

function storeLocalNilaiPertanyaan(objData, localName) {
    let {
        nilai,
        penilaianAsessorId,
        bulan,
        jumlahKaryawan,
        jumlahJamKerja,
        jumlahJamKerjaKaryawan,
        jumlahKecelakaan,
        jumlahHariHilang
    } = objData;
    let getLocal = getLocalNilaiPertanyaan(localName);
    let data = {
        ...getLocal,
        [penilaianAsessorId]: {
            nilai,
            bulan,
            jumlahKaryawan,
            jumlahJamKerja,
            jumlahJamKerjaKaryawan,
            jumlahKecelakaan,
            jumlahHariHilang
        }
    };
    data = JSON.stringify(data);
    localStorage.setItem(localName, data);
}
function getLocalNilaiPertanyaan(localName) {
    let getLocal = localStorage.getItem(localName);
    if (getLocal) return JSON.parse(getLocal);
    else return null;
}
function cekLocalNilaiPertanyaan(localName) {
    let getLocal = localStorage.getItem(localName);
    if (getLocal) return true;
    else return false;
}
function deleteNilaiPertanyaan(id, localName) {
    let getLocal = getLocalNilaiPertanyaan(localName);
    if (getLocal) {
        delete getLocal[id];
        getLocal = JSON.stringify(getLocal);
        localStorage.setItem(localName, getLocal);
        return true;
    }
    return false;
}
function storeLocalExecutiveSummary(objData, localName) {
    let getLocal = getLocalExecutiveSummary(localName);
    let data = {
        ...getLocal,
        ...objData
    };
    data = JSON.stringify(data);
    localStorage.setItem(localName, data);
}
function getLocalExecutiveSummary(localName) {
    let getLocal = localStorage.getItem(localName);
    if (getLocal) return JSON.parse(getLocal);
    else return null;
}

/**
 *
 * @param {*} getListKriteria ini adalah list kriteria yang ingin difilter
 * @param {*} value ini adalah nilai indikator yang difilter mana aja
 * @param {*} option penambahan option baru 1 attribute type, menentukan pertanyaan atau confirm filter
 */

export const filterListKriteria = function(
    getListKriteria,
    value,
    option = {}
) {
    let type = option.type || 'pertanyaan';
    let listKriteria = getListKriteria;
    if (Array.isArray(listKriteria)) {
        listKriteria = listKriteria.map(kriteria => {
            let { MasterSubKriteria } = kriteria;
            if (Array.isArray(MasterSubKriteria)) {
                MasterSubKriteria = MasterSubKriteria.map(subKriteria => {
                    let { Pertanyaan } = subKriteria;
                    if (Array.isArray(Pertanyaan)) {
                        Pertanyaan = Pertanyaan.filter(pertanyaan => {
                            let { PenilaianAsessor } = pertanyaan;
                            // return Boolean(Array.isArray(PenilaianAsessor) && PenilaianAsessor.length > 0)
                            if (type === 'pertanyaan') {
                                if (value === FILTER_PERTANYAAN.SUDAH_DIISI) {
                                    return PenilaianAsessor[0].nilai;
                                } else if (
                                    value === FILTER_PERTANYAAN.BELUM_DIISI
                                ) {
                                    return !PenilaianAsessor[0].nilai;
                                }

                                return true;
                            } else if (type === 'confirm') {
                                if (value === FILTER_CONFIRM.SUDAH_CONFIRM) {
                                    return PenilaianAsessor[0].confirm;
                                } else if (
                                    value === FILTER_CONFIRM.BELUM_CONFIRM
                                ) {
                                    return !PenilaianAsessor[0].confirm;
                                }

                                return true;
                            }

                            return false;
                        });
                    }

                    if (Array.isArray(Pertanyaan) && Pertanyaan.length > 0) {
                        return {
                            ...subKriteria,
                            Pertanyaan
                        };
                    }
                    return false;
                });
                // filter master subkriteria yang false
                MasterSubKriteria = MasterSubKriteria.filter(
                    subKriteria => subKriteria !== false
                );
            }

            if (
                Array.isArray(MasterSubKriteria) &&
                MasterSubKriteria.length > 0
            ) {
                return {
                    ...kriteria,
                    MasterSubKriteria
                };
            }
            return false;
        });
        listKriteria = listKriteria.filter(kriteria => kriteria !== false);
    }

    return listKriteria;
};

export const funcSleep = function(timer) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(true);
        }, timer);
    });
};

const encodeGetParams = p => 
  Object.entries(p).map(kv => kv.map(encodeURIComponent).join("=")).join("&");

export const objToParams = function (obj) {
    let params = [];
    if (obj && typeof obj === 'object') {
        let arrQuery = Object.keys(obj);
        for (let i = 0; i < arrQuery.length; i++) {
            let element = arrQuery[i];
            params.push(`${element}=${obj[element]}`);
        }
    } else {
        throw new Error('obj must be an object, expected ' + typeof obj);
    }
    // return encodeURI(params.join('&'));
    return encodeGetParams(obj);
};

export const showSwalConfirmation = function ({
    text, 
    title, 
    confirmText, 
    cancelText
  }) {
    let confirm = confirmText || 'Ok'
    let cancel = cancelText || 'Cancel'
    return new Promise((resolve, reject) => {
      swal({
        title,
        text,
        type: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: confirm,
        cancelButtonColor: '#d33',
        cancelButtonText: cancel,
        showCancelButton: true
      })
        .then((res) => resolve(res.value))
        .catch((err) => reject(err))
    })
}
  
export const paramsToObj = function (params) {
    return queryString.parse(String(params).replace('?', ''))
}
export const sortAlphaNum = function (a, b) {
    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;
    var aA = a.replace(reA, "");
    var bA = b.replace(reA, "");
    if (aA === bA) {
        var aN = parseInt(a.replace(reN, ""), 10);
        var bN = parseInt(b.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
        return aA > bA ? 1 : -1;
    }
}
  
export const sortAlphaNumericMasterSheet = function (MasterSheet) {
    let result = [];
    let arrNomor = [];
    MasterSheet.map(item => arrNomor.push(item.nomor));
    arrNomor = arrNomor.sort(sortAlphaNum);
    arrNomor.map((itemNomor) => {
        let getIndex = findIndex(MasterSheet, (itemSheet) => (String(itemSheet.nomor) === String(itemNomor)));
        let getObj = cloneDeep(MasterSheet[getIndex]);
        return result.push(getObj);
    })
    return result;
}

export const toggleValueMasterSheet = ({
    toggle,
    detailSheet,
    strToggle
}) => {
    let result = detailSheet.sheet;
    result = result.map((sheet, index) => {
        let { child, isPertanyaan, PenilaianAssessor } = sheet;
        if (child && child.length > 0) {
            return {
                ...sheet,
                child: toggleValueMasterSheet({
                    toggle,
                    strToggle,
                    detailSheet: { sheet: child }
                }).sheet
            }
        } else if (isPertanyaan) {
            let hide = false;

            if (strToggle === 'pertanyaan') {
                if (toggle.pertanyaan === 1) {
                    if (PenilaianAssessor) {
                        let { nilai } = PenilaianAssessor
                        console.log(nilai, '===')
                        hide = (nilai || nilai === 0) ? false : true;
                    } else hide = true
                } else if (toggle.pertanyaan === 2) {
                    hide = PenilaianAssessor ? true : false
                    if (PenilaianAssessor) {
                        let { nilai } = PenilaianAssessor
                        hide = nilai ? true : false
                    } else hide = false
                }
            } else if (strToggle === 'confirm') {
                if (toggle.confirm === 1) {
                    if (PenilaianAssessor) {
                        let { confirm } = PenilaianAssessor
                        hide = confirm ? false : true
                    } else hide = true
                } else if (toggle.confirm === 2) {
                    if (PenilaianAssessor) {
                        let { confirm } = PenilaianAssessor
                        hide = confirm ? true : false
                    } else hide = false
                }
            }

            return {
                ...sheet,
                hide
            }
        }
        return sheet;
    })

    // let resultB = resultA.map((sheet, index) => {
    //     let { child, isPertanyaan, PenilaianAssessor } = sheet;
    //     if (child && child.length > 0) {
    //         return {
    //             ...sheet,
    //             child: toggleValueMasterSheet(toggle, { sheet: child }).sheet
    //         }
    //     } else if (isPertanyaan) {
    //         let hide = false;

    //         if (toggle.confirm === 1) {
    //             if (PenilaianAssessor) {
    //                 let { confirm } = PenilaianAssessor
    //                 hide = confirm ? false : true
    //             } else hide = true
    //         } else if (toggle.confirm === 2) {
    //             if (PenilaianAssessor) {
    //                 let { confirm } = PenilaianAssessor
    //                 hide = confirm ? true : false
    //             } else hide = false
    //         }

    //         return {
    //             ...sheet,
    //             hide
    //         }
    //     }
    //     return sheet
    // })

    return {
        ...detailSheet,
        sheet: result
    }
}

export const toggleConfirmMasterSheet = function (toggle, detailSheet) {
    let result = cloneDeep(detailSheet.sheet);

    result = result.map((sheet, index) => {
        let { child, isPertanyaan, PenilaianAssessor } = sheet;
        if (child && child.length > 0) {
            return {
                ...sheet,
                child: toggleValueMasterSheet(toggle, { sheet: child }).sheet
            }
        } else if (isPertanyaan) {
            let hide = false;

            if (PenilaianAssessor) {
                let { confirm } = PenilaianAssessor
                if (toggle === 1) {
                    hide = confirm ? false : true
                } else if (toggle === 2) {
                    hide = confirm ? true : false
                }
            }

            return {
                ...sheet,
                hide
            }
        }
        return sheet
    })

    return {
        ...detailSheet,
        sheet: result
    }
}

export const checkChildHide = function (sheet) {
    let { child, isPertanyaan } = sheet
    let isHide = [];
    if (child && child.length > 0) {
        child.map(item => {
            let { isPertanyaan, hide: getHide } = item;
            if (isPertanyaan) isHide.push(Boolean(getHide))
            else isHide.push(false);
        })
        isHide = !isHide.includes(false)
    } else {
        if (isPertanyaan) {
            isHide = sheet.hide
        } else {
            isHide = false;
        }
    }
    return isHide
}

export const customChartLegend = function ({ 
    text,
    indexData,
    data,
    context
}) {
    const meta = context.getDatasetMeta(0)
    const ds = data.datasets[0]
    const arc = meta.data[indexData]
    const custom = (arc && arc.custom) || {}
    const getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
    const arcOpts = context.options.elements.arc;
    let fill = null
    let stroke = null;
    let bw = null
    
    if (custom.backgroundColor) {
        fill = custom.backgroundColor
    } else {
        fill = getValueAtIndexOrDefault(ds.backgroundColor, indexData, arcOpts.backgroundColor)
    }

    if (custom.borderColor) {
        stroke = custom.borderColor
    } else {
        stroke = getValueAtIndexOrDefault(ds.borderColor, indexData, arcOpts.borderColor);
    }

    if (custom.borderWidth) {
        bw = custom.borderWidth
    } else {
        bw = getValueAtIndexOrDefault(ds.borderWidth, indexData, arcOpts.borderWidth)
    }

    return {
        text,
        fillStyle: fill,
        strokeStyle: stroke,
        lineWidth: bw,
        hidden: isNaN(ds.data[indexData]) || meta.data[indexData].hidden,
        indexData
    }
}

export const getDataUpdate = (dataObject) => {
	let dataUpdate = {}
	Object.entries(dataObject).map((items, index) => {
		let [key, value] = items
		if (value || value === 0 || value === false) dataUpdate[key] = value
	})
	return dataUpdate
}



const Helper = {
    getDataUpdate,
    customChartLegend,
    toggleValueMasterSheet,
    setFormatNumber,
    isNullOrEmpty,
    toTitleCase,
    romanize,
    verifikasiToken,
    verifikasiRole,
    getBase64Image,
    newImage,
    verifikasiPimpinan,
    showError,
    getUser,
    convertNaNToZero,
    getWarna,
    storeLocalNilaiPertanyaan,
    cekLocalNilaiPertanyaan,
    getLocalNilaiPertanyaan,
    deleteNilaiPertanyaan,
    showSwalLoading,
    randomNumber,
    storeLocalExecutiveSummary,
    getLocalExecutiveSummary,
    showSwalSuccess,
    filterListKriteria,
    funcSleep,
    objToParams,
    alphabetize,
    showSwalConfirmation,
    paramsToObj,
    sortAlphaNumericMasterSheet,
    sortAlphaNum
};

export default Helper;
